import { createSlice } from "@reduxjs/toolkit";
import {
  LOCAL_STORAGE_USER_TOKEN_KEY,
  LOCAL_STORAGE_USER_DATA_KEY,
} from "../../../utils/app-info";
const initialState = {
  userToken: localStorage.getItem(LOCAL_STORAGE_USER_TOKEN_KEY) ?? "",
  userData: localStorage.getItem(LOCAL_STORAGE_USER_DATA_KEY)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA_KEY) || "{}")
    : {},
};
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserToken: (state, action) => {
      state.userToken = action.payload;
      localStorage.setItem(
        LOCAL_STORAGE_USER_TOKEN_KEY,
        action.payload.toString()
      );
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
      localStorage.setItem(
        LOCAL_STORAGE_USER_DATA_KEY,
        JSON.stringify(action.payload)
      );
    },
    removeUserToken: (state) => {
      state.userToken = "";
      localStorage.removeItem(LOCAL_STORAGE_USER_TOKEN_KEY);
    },
    removeUserData: (state) => {
      state.userToken = "";
      localStorage.removeItem(LOCAL_STORAGE_USER_DATA_KEY);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserToken, removeUserToken, setUserData, removeUserData } =
  userSlice.actions;

export default userSlice.reducer;
